module.exports = __webpack_public_path__ + "img/MobileWallet.ca613428.png";